import { TFunction } from 'i18next'
import { object, SchemaOf, string } from 'yup'

export interface RejectReceiptForm {
  reason?: string
  reasonCode?: string
}

export const getDefaultValues = (): RejectReceiptForm => ({
  reason: '',
  reasonCode: '',
})

export type RejectReceiptFormSchema = SchemaOf<RejectReceiptForm>

export const getValidationSchema = (t: TFunction): RejectReceiptFormSchema =>
  object({
    reason: string().when('reasonCode', {
      is: (val: string | undefined) => !val,
      then: (schema) => schema.required(t('receipts.modal.reject_e_invoice.reason.required')),
      otherwise: (schema) => schema,
    }),
    reasonCode: string(),
  })
